import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';

/**
 * POST /flows/:id/mutations returns `formatFlow` without event-slot-scoped `slot` in some cases.
 * Preserve the in-memory event slot row so the studio view stays consistent with
 * `onFlowUpdated` / `flowGet` behavior until the next full refetch.
 */
export function mergeServerFlowWithClientContext(serverFlow: FlowDto, clientFlow: FlowDto | undefined): FlowDto {
  if (!clientFlow) return serverFlow;
  const slot =
    serverFlow.slot && clientFlow.slot
      ? {
          ...clientFlow.slot,
          ...serverFlow.slot,
          startOffsetMinutes: serverFlow.slot.startOffsetMinutes ?? clientFlow.slot.startOffsetMinutes,
        }
      : (serverFlow.slot ?? clientFlow.slot);
  return { ...serverFlow, slot };
}
